import { render, staticRenderFns } from "./DykProductLocalizationsCard.vue?vue&type=template&id=6ca5d8c2&"
import script from "./DykProductLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./DykProductLocalizationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports